// extracted by mini-css-extract-plugin
export var cardContainer = "_qi-0";
export var cardHeader = "_qi-2";
export var collapsedState = "_qi-3";
export var dragHandle = "_qi-5";
export var dragHandleIcon = "_qi-6";
export var dragging = "_qi-1";
export var titleArea = "_qi-4";